import { useEffect, useRef } from "react";
import supabase from "../supabase-client";

// Live updates for service_providers rows — in practice, CLABE verification.
//
// A verification is asynchronous: pagos-svc queues it, Fintoc sends a real
// 0.01 MXN micro-deposit, and a webhook resolves it roughly 78 seconds later.
// Nothing in the browser knows when that lands, so without this the badge
// stays "Verificando…" until somebody reloads the page — and during a bulk
// backfill that is most of the screen, most of the time.
//
// The callback is held in a ref so callers can pass an inline arrow function
// without tearing down and re-establishing the websocket on every render.
export function useProviderLive(onProviderChange, enabled = true) {
  const cb = useRef(onProviderChange);
  cb.current = onProviderChange;

  useEffect(() => {
    if (!enabled) return undefined;

    const channel = supabase
      .channel("service-providers-live")
      .on(
        "postgres_changes",
        { event: "UPDATE", schema: "public", table: "service_providers" },
        (payload) => {
          if (payload?.new) cb.current?.(payload.new);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [enabled]);
}
